import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Components/Layout/Sidebar';
import Navbar from '../../Components/Layout/Navbar';

const ManagementLayout = () => {
	return (
		<div className=''>
			<Sidebar />
			<div className='w-full'>
				<Navbar />
				<main className='flex justify-center items-center py-10 '>
					<Outlet />
				</main>
			</div>
		</div>
	);
};

export default ManagementLayout;
